import {Injectable} from "@angular/core";
import {CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, Router} from "@angular/router";
import {AuthService} from "./auth.service";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let url: string = state.url;
    return this.checkLogin(url);
  }

  checkLogin(url: string): boolean {
    if (this.authService.isLoggedIn && this.authService.timeStamp&&((new Date()).getTime()-this.authService.timeStamp<3600000)) {
      if (url.indexOf('/user/login') != -1) {
        this.router.navigate(['/dashboard/']);
        return false;
      }
      else if (url.indexOf('/dashboard') != -1) {
        return true;
      }
    } else { // Store the attempted URL for redirecting
      if (url.indexOf('/user/login') != -1) {
        return true;
      }
      else if (url.indexOf('/dashboard') != -1) { // Navigate to the login page with extras
        this.authService.redirectUrl = url;
        this.router.navigate(['/user/login']);
        return false;
      }
    }

  }
}
